import axiosClient from './axiosClient';

const userEventApi = {
  get: (eventId) => {
    const url = `/user-events/${eventId}`;
    return axiosClient.get(url);
  },
  getBulkids: (data) => {
    const url = '/files/bulk';
    return axiosClient.post(url, data);
  },
  getAll: (params) => {
    const url = '/user-events';
    return axiosClient.get(url, { params });
  },
  create: (data) => {
    const url = '/user-events';
    return axiosClient.post(url, data);
  },
  edit: (data) => {
    const url = `/user-events/${data._id}`;
    return axiosClient.put(url, data);
  },
  delete: (eventId) => {
    const url = `/user-events/${eventId}`;
    return axiosClient.delete(url);
  },
  getLink: (eventId) => {
    const url = `/user-events/${eventId}/join`;
    return axiosClient.get(url);
  },
  getLinkBBB: (eventId, accessCode) => {
    const url = `/rooms/${eventId}/join`;
    if (accessCode) {
      return axiosClient.get(url, { params: { accessCode } });
    }
    return axiosClient.get(url);
  },
  getEventParticipant: (eventId) => {
    const url = `/user-events/${eventId}/participant`;
    return axiosClient.get(url);
  },
  getPlayback: (eventId) => {
    const url = `/user-events/${eventId}/playback`;
    return axiosClient.get(url);
  },
  getEventHistories: (eventId) => {
    const url = `/user-events/${eventId}/histories`;
    return axiosClient.get(url);
  },
  getLearnerData: (params) => {
    const url = `user-courses/get-all-intakes`;
    return axiosClient.get(url, { params });
  },
  getLiveClassRunning: (params) => {
    const url = `/user-events/get-learner-events-live`;
    return axiosClient.get(url, { params });
  },
};

export default userEventApi;
